import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationController } from 'aurelia-validation';
import { EntityWideDeviationRequest } from 'model/forms/deviation-request';
import { LookupsService } from 'services/lookups-service';

@customElement('deviation-request-aviation-coe-panel')
export class DeviationRequestAviationCOEPanelCustomElement {
  @bindable model: EntityWideDeviationRequest;
  @bindable disabled: boolean;
  @bindable supportValidationController: ValidationController;

  constructor(protected lookups: LookupsService) {
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();

  @computedFrom('model.aviationCOE')
  get aviationCOEGroupLabel() {
    return ['Aviation Discipline Manager / bp employee name', this.model.aviationCOE?.mail, this.model.aviationCOE?.phone].filter(l => l != null);
  }
}
